let searchForm;
let templateRequest;

function searchSubmitted( e ) {
	if( e ) { e.preventDefault(); }
	const query = searchForm.querySelector( 'input[type="search"]' ).value.trim();
	if( !query.length ) { return; }

	const requestUrl = `${searchForm.action}&filter[fulltext]=${encodeURIComponent( query )}`;

	if( templateRequest ) {
		templateRequest( requestUrl );
	}
}

function setupTemplateRequest( getData ) {
	templateRequest = getData;
}

function errorState() {
	if( !searchForm ) { return; }
	searchForm.querySelector( 'input[type="search"]' ).value = '';
}

function renderSearch( results ) {
	if( !searchForm || !results || !results?.links?.self?.href ) {
		errorState();
		return;
	}

	const query = retrieveSearchTerm( results );
	searchForm.querySelector( 'input[type="search"]' ).value = decodeURI(query);
}

function retrieveSearchTerm( results ) {
	if( !results || !results?.links?.self?.href ) {
		return;
	}

	let query = '';
	
	const queryString = `?${results.links.self.href.indexOf( '?' ) >= 0 ? results.links.self.href.split( '?' )[1] : ''}`;
	if( queryString && queryString.length && queryString.indexOf( '?filter' ) >= 0 || queryString.indexOf( '&filter' ) >= 0 ) {
		// Filters are present on URL
		const params = queryString.split( '&' );
		for( let i = 0; i < params.length; i += 1 ) {
			const split = params[i].split( '=' );
			if( split[0].indexOf( 'fulltext' ) >= 0 ) {
				// query filter is present on the URL, pull it
				// eslint-disable-next-line prefer-destructuring
				query = split[1].trim();
				break;
			}
		}
	}

	return query;
}

function init() {
	searchForm = document.querySelector( '.hero--appstore__tools__search form' );
	if( !searchForm ) { return; }

	searchForm.removeEventListener( 'submit', searchSubmitted );
	searchForm.addEventListener( 'submit', searchSubmitted );
}

if (
    document.readyState === "complete" ||
    (document.readyState !== "loading" && !document.documentElement.doScroll)
) {
  init();
} else {
	document.removeEventListener( 'DOMContentLoaded', init );
  document.addEventListener( 'DOMContentLoaded', init );
}

export default {
	setupTemplateRequest, // call this to setup the 2-way communication
	renderSearch, // call this when the page recieves new data
	retrieveSearchTerm, // call this to get search term
};